// @flow
import Administration from "./administrationPage";

export { ADMINISTRATION_QUERY } from "./administrationPage";

export default Administration;
